<template>
  <!-- 自定义模态框替换 el-dialog -->
  <div v-if="visible" class="custom-modal-overlay">

    <div class="custom-modal" @click.stop>

      <!-- 添加处理中覆盖层 -->
      <div v-if="isLoginProcessing" class="processing-overlay">
        <div class="processing-content">
          <el-icon class="processing-icon" :size="32">
            <Loading />
          </el-icon>
        </div>
      </div>

      <!-- 左右布局容器 -->
      <div class="modal-body">
        <!-- 左侧图片区域 -->
<!--        <div class="modal-image">-->
<!--          <img :src="loginImage" alt="登录" />-->
<!--        </div>-->

        <!-- 右侧表单区域 -->
        <div class="modal-form-wrapper">
          <!-- 关闭按钮 -->
          <el-icon class="close-btn" @click="handleClose">
            <Close />
          </el-icon>

          <!-- 顶部登录提示 -->
          <div class="modal-header">
            <h3>{{ getLoginTitle() }}</h3>
          </div>

          <!-- 账号登录表单 -->
          <el-form
              v-if="loginMethod === 'account'"
              ref="accountLoginFormRef"
              :model="accountLoginForm"
              @submit.prevent="handleAccountLogin"
              class="modal-form"
          >
            <el-form-item prop="account">
              <el-input
                  v-model="accountLoginForm.account"
                  placeholder="请输入账号或手机号"
                  size="large"
                  clearable
                  class="modal-elegant-input"
                  autocomplete="off"
                  @input="clearAccountErrors"
              >
                <template #prefix>
                  <el-icon><User /></el-icon>
                </template>
              </el-input>
              <div v-if="accountError" class="error-message">
                <el-icon><WarningFilled /></el-icon>
                <span>{{ accountError }}</span>
              </div>
            </el-form-item>

            <el-form-item prop="password">
              <el-input
                  v-model="accountLoginForm.password"
                  type="password"
                  placeholder="请输入密码"
                  size="large"
                  show-password
                  class="modal-elegant-input"
                  autocomplete="new-password"
                  @input="clearPasswordErrors"
              >
                <template #prefix>
                  <el-icon><Lock /></el-icon>
                </template>
              </el-input>
              <div v-if="passwordError" class="error-message">
                <el-icon><WarningFilled /></el-icon>
                <span>{{ passwordError }}</span>
              </div>
            </el-form-item>

            <div class="login-footer">
              <el-link type="info" class="forgot-password" @click="handleForgotPassword">忘记密码?</el-link>
            </div>

            <el-form-item>
              <el-button
                  type="primary"
                  size="large"
                  native-type="submit"
                  class="login-btn"
                  :loading="loading"
              >
                登录
              </el-button>
            </el-form-item>
          </el-form>

          <!-- 手机登录表单 -->
          <el-form
              v-if="loginMethod === 'phone'"
              ref="phoneLoginFormRef"
              :model="phoneLoginForm"
              @submit.prevent="handlePhoneLogin"
              class="modal-form"
          >
            <el-form-item prop="phone">
              <el-input
                  v-model="phoneLoginForm.phone"
                  placeholder="请输入手机号"
                  size="large"
                  clearable
                  class="modal-elegant-input"
                  autocomplete="off"
                  @input="clearPhoneErrors"
              >
                <template #prefix>
                  <el-icon><Iphone /></el-icon>
                </template>
              </el-input>
              <div v-if="phoneError" class="error-message">
                <el-icon><WarningFilled /></el-icon>
                <span>{{ phoneError }}</span>
              </div>
            </el-form-item>

            <el-form-item prop="captcha">
              <el-input
                  v-model="phoneLoginForm.captcha"
                  placeholder="请输入验证码"
                  size="large"
                  class="modal-elegant-input"
                  autocomplete="off"
                  @input="clearCaptchaErrors"
              >
                <template #prefix>
                  <el-icon><Message /></el-icon>
                </template>
                <template #suffix>
                  <el-button
                      link
                      class="captcha-btn"
                      :disabled="captchaCooldown > 0"
                      @click="sendCaptcha"
                  >
                    {{ captchaCooldown > 0 ? `${captchaCooldown}秒后重试` : '获取验证码' }}
                  </el-button>
                </template>
              </el-input>
              <div v-if="captchaSuccess" class="success-message">
                <el-icon><SuccessFilled /></el-icon>
                <span>{{ captchaSuccess }}</span>
              </div>
              <div v-if="captchaError" class="error-message">
                <el-icon><WarningFilled /></el-icon>
                <span>{{ captchaError }}</span>
              </div>
            </el-form-item>

            <div class="login-footer">
              <el-link type="info" class="forgot-password" @click="handleForgotPassword">忘记密码?</el-link>
            </div>

            <el-form-item>
              <el-button
                  type="primary"
                  size="large"
                  native-type="submit"
                  class="login-btn"
                  :loading="loading"
              >
                登录
              </el-button>
            </el-form-item>
          </el-form>

          <!-- 微信登录表单 -->
          <div v-if="loginMethod === 'wechat'" class="wechat-login-container">
            <div v-if="wechatQrCodeUrl" class="wechat-qrcode">
              <img :src="wechatQrCodeUrl" alt="微信登录二维码">
              <p class="tip">请使用微信扫一扫登录</p>
            </div>
            <div v-else class="loading-qrcode">
              正在生成二维码...
            </div>
          </div>

          <!-- 注册链接 -->
          <div v-if="loginMethod !== 'wechat'" class="register-link">
            <span>还没有账号？</span>
            <el-link type="primary" @click="switchToRegister">去注册</el-link>
          </div>

          <!-- 登录方式选择 -->
          <div class="login-method-wrapper">
            <div class="login-method-container">
              <div class="login-method-tabs">
                <el-button
                    v-if="loginMethod !== 'phone'"
                    :class="['method-button', 'icon-only']"
                    @click="loginMethod = 'phone'"
                    size="large"
                    text
                >
                  <svg t="1761617897590" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5998" width="28" height="28">
                    <path d="M724.350707 63.353535H297.787475C253.310707 63.353535 217.212121 99.555556 217.212121 143.928889v736.245656c0 44.476768 36.20202 80.575354 80.575354 80.575354h426.563232c44.476768 0 80.575354-36.20202 80.575354-80.575354V143.928889c0-44.476768-36.098586-80.575354-80.575354-80.575354zM297.787475 104.727273h426.563232c21.617778 0 39.201616 17.583838 39.201616 39.201616V179.717172H258.585859v-35.788283C258.585859 122.311111 276.169697 104.727273 297.787475 104.727273zM258.585859 221.090909h505.069899v527.72202H258.585859V221.090909z m465.764848 698.285253H297.787475c-21.617778 0-39.201616-17.583838-39.201616-39.201617v-89.987878h505.069899v89.987878c-0.103434 21.617778-17.687273 39.201616-39.305051 39.201617z m0 0" fill="#efb336" p-id="5999"></path>
                    <path d="M435.975758 149.721212h150.083232c8.274747 0 14.99798-6.723232 14.99798-14.99798 0-8.274747-6.723232-14.99798-14.99798-14.997979H435.975758c-8.274747 0-14.99798 6.723232-14.99798 14.997979 0 8.274747 6.723232 14.99798 14.99798 14.99798z m0 0M457.490101 855.660606c0 19.135354 10.214141 36.822626 26.789495 46.403232 16.575354 9.567677 37.003636 9.567677 53.57899 0a53.575111 53.575111 0 0 0 26.789495-46.403232c0-29.595152-23.983838-53.57899-53.57899-53.57899-29.595152 0-53.57899 23.983838-53.57899 53.57899z m0 0" fill="#efb336" p-id="6000"></path>
                  </svg>
                </el-button>

                <el-button
                    v-if="loginMethod !== 'wechat'"
                    :class="['method-button', 'icon-only']"
                    @click="handleWechatLogin"
                    size="large"
                    text
                >
                  <svg t="1761617723278" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4874" width="28" height="28">
                    <path d="M1024 619.52c0-143.36-138.24-256-307.2-256s-307.2 112.64-307.2 256 138.24 256 307.2 256c30.72 0 61.44-5.12 92.16-10.24l97.28 51.2-25.6-76.8c87.04-51.2 143.36-128 143.36-220.16z m-414.72-40.96c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2 51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z m209.92 0c-30.72 0-51.2-20.48-51.2-51.2s20.48-51.2 51.2-51.2 51.2 20.48 51.2 51.2c0 25.6-25.6 51.2-51.2 51.2z" fill="#4CBF00" p-id="4875"></path>
                    <path d="M358.4 609.28c0-158.72 153.6-286.72 348.16-286.72h15.36c-40.96-133.12-179.2-235.52-353.28-235.52-204.8 0-368.64 138.24-368.64 307.2 0 107.52 66.56 204.8 168.96 256l-30.72 92.16L256 686.08c35.84 10.24 71.68 15.36 112.64 15.36h10.24c-15.36-30.72-20.48-61.44-20.48-92.16z m138.24-414.72c35.84 0 66.56 30.72 66.56 66.56s-30.72 66.56-66.56 66.56C460.8 322.56 430.08 291.84 430.08 256S460.8 194.56 496.64 194.56zM245.76 322.56c-35.84 0-61.44-30.72-61.44-66.56s30.72-66.56 66.56-66.56 61.44 30.72 61.44 66.56-30.72 66.56-66.56 66.56z" fill="#4CBF00" p-id="4876"></path>
                  </svg>
                </el-button>

                <el-button
                    v-if="loginMethod !== 'account'"
                    :class="['method-button', 'icon-only']"
                    @click="loginMethod = 'account'"
                    size="large"
                    text
                >
                  <svg t="1761617971743" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7068" width="28" height="28">
                    <path d="M522.24 61.44c112.64 0 204.8 92.16 204.8 204.8s-92.16 204.8-204.8 204.8-204.8-92.16-204.8-204.8 92.16-204.8 204.8-204.8m0-51.2c-143.36 0-256 112.64-256 256s112.64 256 256 256 256-112.64 256-256-112.64-256-256-256z" fill="#7dc5eb" p-id="7069"></path>
                    <path d="M512 471.04v51.2c71.68 0 133.12 10.24 168.96 15.36 15.36 0 30.72 10.24 46.08 15.36 10.24 5.12 15.36 5.12 25.6 10.24 163.84 76.8 220.16 209.92 199.68 307.2-10.24 40.96-35.84 92.16-87.04 97.28H153.6c-46.08 0-71.68-46.08-81.92-87.04-20.48-97.28 30.72-235.52 204.8-317.44 71.68-25.6 148.48-35.84 235.52-35.84V471.04m0 0c-76.8 0-168.96 10.24-256 40.96-337.92 158.72-276.48 501.76-102.4 501.76h716.8c179.2-15.36 220.16-353.28-102.4-501.76-5.12 0-46.08-15.36-76.8-20.48-46.08-10.24-107.52-20.48-179.2-20.48z" fill="#7dc5eb" p-id="7070"></path>
                  </svg>
                </el-button>
              </div>
            </div>
          </div>

          <!-- 用户协议和隐私政策 -->
          <div v-if="loginMethod !== 'wechat'" class="agreement">
            <div class="agreement-content">
              <el-checkbox
                  v-model="agreeToTerms"
                  class="agree-checkbox"
                  @click.stop
              >
                我已阅读并同意
              </el-checkbox>
              <div class="agreement-links">
                <el-link type="primary" @click="showTermsDialog">《用户协议》</el-link>
                <span>和</span>
                <el-link type="primary" @click="showPrivacyDialog">《隐私政策》</el-link>
              </div>
            </div>
          </div>
          <div v-if="loginMethod === 'wechat'" class="agreement">
            登录即表示同意
            <el-link type="primary" @click="showTermsDialog">《用户协议》</el-link>
            和
            <el-link type="primary" @click="showPrivacyDialog">《隐私政策》</el-link>
          </div>
        </div>
      </div>

    </div>

  </div>

  <!-- 服务条款弹窗 -->
  <el-dialog
      v-model="termsDialogVisible"
      :title="null"
      width="60%"
      top="8vh"
      class="policy-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <template #header>
      <div class="dialog-header">
        <h3>用户协议</h3>
      </div>
    </template>
    <div class="dialog-content" v-html="termsContent"></div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="termsDialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 隐私政策弹窗 -->
  <el-dialog
      v-model="privacyDialogVisible"
      :title="null"
      width="60%"
      top="8vh"
      class="policy-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
  >
    <template #header>
      <div class="dialog-header">
        <h3>隐私政策</h3>
      </div>
    </template>
    <div class="dialog-content" v-html="privacyContent"></div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="privacyDialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 绑定手机弹窗 -->
  <BindPhoneDialog
      v-model="bindPhoneDialogVisible"
      :session-id="currentSessionId"
      @bind-success="handleBindSuccess"
  />
</template>

<script setup>
import { ref, reactive, computed, watch, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import request from '@/utils/request'
import { eventBus } from '@/utils/eventBus'
import { useRouter } from 'vue-router'
import BindPhoneDialog from '@/components/BindPhoneDialog.vue'

const router = useRouter()

// 属性定义
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  paymentInfo: {
    type: Object,
    default: () => ({})
  }
})

// 事件定义
const emit = defineEmits(['update:modelValue', 'login-success', 'switch-to-register'])

// 响应式数据
const visible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

// 添加登录成功加载状态
const isLoginProcessing = ref(false)
const loginProcessingText = ref('')

const loginMethod = ref('account')
const loading = ref(false)
const captchaCooldown = ref(0)
const agreeToTerms = ref(false)

const bindPhoneDialogVisible = ref(false)

// 弹窗控制变量
const termsDialogVisible = ref(false)
const privacyDialogVisible = ref(false)

// 用户协议内容
const termsContent = ref(`
  <h2>易比图工具用户协议</h2>
  <p><strong>版本日期：2025年8月26日</strong></p>
  <p>本协议是您（以下简称"用户"）与易印公司（以下简称"本公司"）就使用易比图工具（以下简称"本软件"）服务所订立的协议。请您在注册、下载、安装或使用本软件及相关服务前，仔细阅读并充分理解本协议。</p>

  <h3>1. 服务内容</h3>
  <ul>
    <li>本软件提供屏幕截图图片比对与差异显示功能，主要用于包装印刷等视觉校对场景。</li>
    <li>本软件的比对结果仅供参考，最终决定应由用户自行或由专业人员确认。</li>
  </ul>

  <h3>2. 使用规范</h3>
  <ul>
    <li>用户不得将本软件用于任何违法、侵权或未经授权的用途。</li>
    <li>用户在使用本软件过程中产生的所有行为及后果，由用户自行承担。</li>
    <li>用户应自行做好数据备份和安全防护。</li>
  </ul>

  <h3>3. 知识产权</h3>
  <ul>
    <li>本软件及其全部内容，包括但不限于代码、界面设计、图标（含SVG图标）、文字、图像等，均受著作权法及相关法律保护，归本公司所有。</li>
    <li>未经本公司书面许可，用户不得复制、修改、出售、反向工程或以其他方式使用本软件的全部或部分内容。</li>
  </ul>

  <h3>4. 免责声明与责任限制</h3>
  <ul>
    <li>因用户依赖比对结果造成的任何直接或间接损失，本公司不承担责任。</li>
    <li>因不可抗力（包括但不限于自然灾害、网络故障、系统故障）导致的服务中断或数据丢失，本公司不承担责任。</li>
  </ul>

  <h3>5. 服务变更与终止</h3>
  <ul>
    <li>本公司保留随时修改、暂停或终止全部或部分服务的权利，并将在官网公告或通过适当方式提前通知用户。</li>
    <li>用户有权随时停止使用本软件。</li>
  </ul>

  <h3>6. 法律适用与争议解决</h3>
  <ul>
    <li>本协议的签订、履行、解释及争议解决均适用中华人民共和国法律。</li>
    <li>双方因本协议产生的争议，应友好协商解决；协商不成的，应提交至本公司所在地人民法院诉讼解决。</li>
  </ul>
`)

// 隐私政策内容
const privacyContent = ref(`
  <h2>易比图工具隐私政策</h2>
  <p><strong>版本日期：2025年8月26日</strong></p>
  <p>本隐私政策旨在说明本公司在您使用本软件及相关服务过程中，如何收集、使用、存储和保护您的个人信息。</p>

  <h3>1. 信息收集</h3>
  <ul>
    <li><strong>注册信息</strong>：包括姓名、邮箱、联系电话等（如适用）。</li>
    <li><strong>使用数据</strong>：包括软件功能使用频率、比对任务类型、错误日志（不含比对图片内容本身）。</li>
    <li><strong>设备信息</strong>：包括操作系统类型、版本号、硬件型号等。</li>
  </ul>

  <h3>2. 信息使用</h3>
  <ul>
    <li>提供、维护和优化本软件的功能与性能。</li>
    <li>为用户提供技术支持与更新通知。</li>
    <li>在用户同意的情况下，用于发送产品资讯或营销活动信息。</li>
  </ul>

  <h3>3. 信息存储与保护</h3>
  <ul>
    <li>本公司采取符合行业标准的安全措施保护用户数据，防止未经授权的访问、披露、篡改或毁坏。</li>
    <li>除法律法规另有规定外，本公司仅在为实现本政策所述目的所必需的期限内保存用户信息。</li>
  </ul>

  <h3>4. 信息共享</h3>
  <ul>
    <li>本公司不会向第三方出售或出租用户信息。</li>
    <li>仅在以下情况下共享用户信息：
      <ul>
        <li>获得用户事先同意；</li>
        <li>法律法规或政府机关要求；</li>
        <li>为维护本公司合法权益所必需。</li>
      </ul>
    </li>
  </ul>

  <h3>5. 用户权利</h3>
  <ul>
    <li>用户可随时访问、更正或删除其个人信息（法律法规另有规定的除外）。</li>
    <li>用户可撤回同意，但可能会影响某些功能的使用。</li>
  </ul>

  <h3>6. 政策更新</h3>
  <ul>
    <li>本公司可能会不时更新本政策，并通过官网或其他适当方式通知用户。</li>
    <li>更新后的政策自发布之日起生效。</li>
  </ul>
`)

// 表单数据
const accountLoginForm = reactive({
  account: '',
  password: ''
})

const phoneLoginForm = reactive({
  phone: '',
  captcha: ''
})

// 错误提示
const accountError = ref('')
const passwordError = ref('')
const phoneError = ref('')
const captchaError = ref('')
const captchaSuccess = ref('')
const wechatQrCodeUrl = ref('')
const currentSessionId = ref('')
let pollingTimer = null

// 计算属性
const loginImage = computed(() => {
  const images = {
    account: require('@/assets/login/login-account.jpg'),
    phone: require('@/assets/login/login-phone.jpg'),
    wechat: require('@/assets/login/login-wechat.jpg')
  }
  return images[loginMethod.value] || images.account
})

// 方法
const getLoginTitle = () => {
  switch (loginMethod.value) {
    case 'account': return '账号登录'
    case 'phone': return '手机登录'
    case 'wechat': return '微信登录'
    default: return '登录'
  }
}

const handleClose = () => {
  isLoginProcessing.value = false
  loginProcessingText.value = ''
  visible.value = false
  resetForm()
}

const switchToRegister = () => {
  emit('switch-to-register')
}

const resetForm = () => {
  accountLoginForm.account = ''
  accountLoginForm.password = ''
  phoneLoginForm.phone = ''
  phoneLoginForm.captcha = ''
  accountError.value = ''
  passwordError.value = ''
  phoneError.value = ''
  captchaError.value = ''
  captchaSuccess.value = ''
  loading.value = false
  agreeToTerms.value = false

  // 清理轮询
  clearPolling();

  isLoginProcessing.value = false
  loginProcessingText.value = ''
}

// 清除错误提示
const clearAccountErrors = () => { accountError.value = '' }
const clearPasswordErrors = () => { passwordError.value = '' }
const clearPhoneErrors = () => { phoneError.value = '' }
const clearCaptchaErrors = () => {
  captchaError.value = ''
  captchaSuccess.value = ''
}

// 验证方法
const validateAccount = (account) => {
  if (!account) return '请输入账号'
  return ''
}

const validatePassword = (password) => {
  if (!password) return '请输入密码'
  if (password.length < 6) return '密码长度至少为6位'
  return ''
}

const validatePhone = (phone) => {
  if (!phone) return '请输入手机号'
  if (!/^1[3-9]\d{9}$/.test(phone)) return '请输入正确的手机号'
  return ''
}

const validateCaptcha = (captcha) => {
  if (!captcha) return '请输入验证码'
  if (captcha.length !== 6) return '验证码为6位数字'
  return ''
}

// 倒计时
const startCountdown = (countdownRef, seconds = 60) => {
  countdownRef.value = seconds
  const timer = setInterval(() => {
    countdownRef.value--
    if (countdownRef.value <= 0) clearInterval(timer)
  }, 1000)
}

// 账号登录
const handleAccountLogin = async () => {
  if (!agreeToTerms.value) {
    ElMessage.error('请先阅读并同意用户协议和隐私政策')
    return
  }

  clearAccountErrors()
  clearPasswordErrors()

  let isValid = true
  accountError.value = validateAccount(accountLoginForm.account)
  if (accountError.value) isValid = false

  passwordError.value = validatePassword(accountLoginForm.password)
  if (passwordError.value) isValid = false

  if (!isValid) return

  try {
    loading.value = true
    const response = await request.post('/auth/login/account', {
      account: accountLoginForm.account,
      password: accountLoginForm.password,
      type: '1',
      sin: ''
    })

    if (response.code === '200') {
      const { token, hasBoundPhone } = response.data

      // 确保token存储完成
      localStorage.setItem('auth_token', token)
      console.log('模态框登录Token存储完成:', localStorage.getItem('auth_token'));

      // 显示处理状态
      isLoginProcessing.value = true
      // loginProcessingText.value = '登录成功，正在处理...'

      // 触发登录事件，让Layout开始加载用户信息
      eventBus.emitLogin()

      // 等待用户信息加载完成
      await new Promise(resolve => setTimeout(resolve, 600));

      // 关闭处理状态
      isLoginProcessing.value = false
      loginProcessingText.value = ''

      ElMessage.success('登录成功')
      handleClose()
      emit('login-success', {
        token,
        hasBoundPhone,
        paymentInfo: props.paymentInfo
      })
    } else {
      ElMessage.error(response.message || '登录失败')
    }
  } catch (error) {
    isLoginProcessing.value = false
    loginProcessingText.value = ''
    if (error.response?.data?.message) {
      if (error.response.data.message.includes('账号')) {
        accountError.value = error.response.data.message
      } else if (error.response.data.message.includes('密码')) {
        passwordError.value = error.response.data.message
      } else {
        ElMessage.error(error.response.data.message)
      }
    }
    console.error('登录错误:', error)
  } finally {
    loading.value = false
  }
}

// 手机登录
const handlePhoneLogin = async () => {
  if (!agreeToTerms.value) {
    ElMessage.error('请先阅读并同意用户协议和隐私政策')
    return
  }

  clearPhoneErrors()
  clearCaptchaErrors()

  let isValid = true
  phoneError.value = validatePhone(phoneLoginForm.phone)
  if (phoneError.value) isValid = false

  captchaError.value = validateCaptcha(phoneLoginForm.captcha)
  if (captchaError.value) isValid = false

  if (!isValid) return

  try {
    loading.value = true
    const response = await request.post('/auth/login/phone', {
      phone: phoneLoginForm.phone,
      verifyCode: phoneLoginForm.captcha,
      type: '1',
      sin: ''
    })

    if (response.code === '200') {
      const { token, hasBoundPhone } = response.data

      // 确保token存储完成
      localStorage.setItem('auth_token', token)
      console.log('模态框手机登录Token存储完成:', localStorage.getItem('auth_token'));

      // 显示处理状态
      isLoginProcessing.value = true
      // loginProcessingText.value = '登录成功，正在处理...'

      // 触发登录事件
      eventBus.emitLogin()

      // 等待用户信息加载完成
      await new Promise(resolve => setTimeout(resolve, 600));

      // 关闭处理状态
      isLoginProcessing.value = false
      loginProcessingText.value = ''

      ElMessage.success('登录成功')
      handleClose()
      emit('login-success', {
        token,
        hasBoundPhone,
        paymentInfo: props.paymentInfo
      })
    } else {
      ElMessage.error(response.message || '登录失败')
    }
  } catch (error) {
    isLoginProcessing.value = false
    loginProcessingText.value = ''

    if (error.response?.data?.message) {
      if (error.response.data.message.includes('校验码')) {
        captchaError.value = '校验码已过期，请重新获取'
      } else if (error.response.data.message.includes('验证码')) {
        captchaError.value = '验证码错误，请重新输入'
      } else if (error.response.data.message.includes('手机')) {
        phoneError.value = '该手机号未注册'
      } else {
        ElMessage.error(error.response.data.message)
      }
    }
    console.error('登录错误:', error)
  } finally {
    loading.value = false
  }
}

// 发送验证码
const sendCaptcha = async () => {
  clearPhoneErrors()
  clearCaptchaErrors()

  phoneError.value = validatePhone(phoneLoginForm.phone)
  if (phoneError.value) return

  try {
    const response = await request.get('/auth/verify-code/phone', {
      params: {
        phone: phoneLoginForm.phone,
        scene: 'Login'
      }
    })

    if (response.code === '200') {
      startCountdown(captchaCooldown, 60)
      captchaSuccess.value = '短信验证码已发送，可能会有延后，请耐心等待'
    } else {
      ElMessage.error(response.message || '验证码发送失败')
    }
  } catch (error) {
    ElMessage.error('验证码发送错误: ' + (error.response?.data?.message || error.message))
  }
}

const handleWechatLogin = async () => {
  loginMethod.value = 'wechat'

  // 清理之前的轮询
  clearPolling();

  wechatQrCodeUrl.value = ''

  try {
    const response = await request.get('/auth/wechat/mp-qrcode')
    const { qrUrl, sessionId } = response.data

    wechatQrCodeUrl.value = qrUrl
    currentSessionId.value = sessionId
    startPolling()
  } catch (error) {
    // ElMessage.error('获取二维码失败')
  }
}

const startPolling = () => {
  clearPolling();

  const poll = async () => {
    if (loginMethod.value !== 'wechat') {
      clearPolling();
      return
    }

    try {
      const statusRes = await request.get('/auth/wechat/login/status', {
        params: { sessionId: currentSessionId.value }
      })

      const responseData = statusRes.data || {}

      if (responseData.status === 'success') {
        const token = responseData.token
        const hasBoundPhone = responseData.hasBoundPhone

        // 确保token存储完成
        localStorage.setItem('auth_token', token)
        console.log('模态框微信登录Token存储完成:', localStorage.getItem('auth_token'));

        // 显示处理状态
        isLoginProcessing.value = true
        // loginProcessingText.value = '登录成功，正在处理...'

        // 触发登录事件
        eventBus.emitLogin()

        // 等待用户信息加载完成
        await new Promise(resolve => setTimeout(resolve, 600));

        // 关闭处理状态
        isLoginProcessing.value = false
        loginProcessingText.value = ''

        if (hasBoundPhone) {
          ElMessage.success('微信登录成功')
          clearPolling();
          handleClose()
          emit('login-success', {
            token,
            hasBoundPhone,
            paymentInfo: props.paymentInfo
          })
        } else {
          // 显示绑定手机弹窗
          bindPhoneDialogVisible.value = true
        }
      }  else if (responseData.status === 'waiting_bind') {
        // 等待绑定手机的状态
        bindPhoneDialogVisible.value = true
      } else if (responseData.status === 'expired') {
        ElMessage.warning('二维码已过期，正在重新生成...')
        handleWechatLogin()
      } else if (responseData.status === 'waiting') {
        pollingTimer = setTimeout(poll, 2000)
      }
    } catch (error) {
      console.error('轮询错误:', error)
      pollingTimer = setTimeout(poll, 2000)
    }
  }

  pollingTimer = setTimeout(poll, 2000)
}


// 清理轮询函数
const clearPolling = () => {
  if (pollingTimer) {
    clearTimeout(pollingTimer)
    pollingTimer = null
  }
}

// 处理绑定成功
const handleBindSuccess = () => {
  ElMessage.success('绑定成功！')

  // 显示处理状态
  isLoginProcessing.value = true
  // loginProcessingText.value = '正在处理...'

  // 触发登录事件
  eventBus.emitLogin()

  // 等待用户信息加载完成后再关闭
  setTimeout(() => {
    isLoginProcessing.value = false
    loginProcessingText.value = ''
    clearPolling();
    handleClose()
    emit('login-success', {
      paymentInfo: props.paymentInfo
    })
  }, 600);
}

// 忘记密码处理方法
const handleForgotPassword = () => {
  handleClose()
  // 使用 setTimeout 确保模态框完全关闭后再跳转
  setTimeout(() => {
    router.push('/updatePassword')
  }, 300)
}

// 显示对话框的方法
const showTermsDialog = () => {
  termsDialogVisible.value = true
}

const showPrivacyDialog = () => {
  privacyDialogVisible.value = true
}

// 监听 visible 变化
watch(visible, (newVal) => {
  if (newVal) {
    // 显示时锁定滚动
    document.body.style.overflow = 'hidden'
  } else {
    // 隐藏时恢复滚动
    document.body.style.overflow = ''
    resetForm()

  }
})

// 组件卸载时清理轮询
onUnmounted(() => {
  clearPolling();
})
</script>

<style scoped lang="scss">

.processing-overlay {
  position: absolute; /* 改为绝对定位，相对于模态框 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  backdrop-filter: blur(8px); /* 只保留模糊效果 */
  -webkit-backdrop-filter: blur(8px);
  animation: fadeIn 0.3s ease-out;
  border-radius: 0; /* 移除圆角 */
}

/* 移除白色背景和阴影，只保留图标 */
.processing-content {
  text-align: center;
  /* 移除所有背景、内边距、阴影等 */
  background: transparent;
  padding: 0;
  box-shadow: none;
  border-radius: 0;
  animation: none; /* 移除缩放动画 */
}

.processing-icon {
  color: #409EFF;
  animation: spin 1.2s linear infinite;
  /* 移除下边距，因为已经没有文本了 */
  margin-bottom: 0;
}

/* 移除文本相关样式 */
.processing-text {
  display: none; /* 隐藏文本 */
}

/* 简化淡入动画，只处理模糊效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
    -webkit-backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
  }
}

/* 移除缩放动画，因为不需要了 */
/* @keyframes scaleIn 已移除 */

/* 旋转动画保持不变 */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* 确保模态框本身也有平滑的动画 */
.custom-modal-overlay {
  animation: modalFadeIn 0.3s ease-out;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    backdrop-filter: blur(0px);
  }
  to {
    opacity: 1;
    backdrop-filter: blur(4px);
  }
}

/* 自定义模态框样式 */
.custom-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.custom-modal {
  width: 400px;
  height: 500px;
  background: white;
  border-radius: 0;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-body {
  display: flex;
  width: 100% !important;
  height: 100% !important;
  padding: 0;
  margin: 0;
}

.modal-image {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  margin: 0;
  padding: 1px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.modal-form-wrapper {
  flex: 1;
  padding: 40px;
  position: relative;
  display: flex;
  flex-direction: column;
  background: white;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 18px;
  cursor: pointer;
  color: #999;
  z-index: 10;

  &:hover {
    color: #409EFF;
  }
}

.modal-header {
  margin-bottom: 25px;
  text-align: center;

  h3 {
    font-size: 24px;
    color: #2c3e50;
    margin-bottom: 8px;
    font-weight: 600;
  }
}

.modal-form {
  flex: 1;
  display: flex;
  flex-direction: column;

  :deep(.el-form-item) {
    margin-bottom: 10px;
  }
}

.modal-elegant-input {
  :deep(.el-input__wrapper) {
    border-radius: 0;
    padding: 1px 12px;
    box-shadow: 0 0 0 1px #dcdfe6 inset;
    height: 38px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 0 0 1px #c0c4cc inset;
    }

    &.is-focus {
      box-shadow: 0 0 0 1px #409EFF inset;
    }
  }

  :deep(.el-input__inner) {
    line-height: 36px;
    font-size: 14px;
    color: #606266;
  }

  :deep(.el-input__prefix) {
    left: 8px;
    color: #606266;
  }

  :deep(.el-input__suffix) {
    display: flex;
    align-items: center;
    padding-right: 8px;
  }

  .captcha-btn {
    padding: 0;
    height: auto;
    color: #373737;
    font-size: 13px;
    white-space: nowrap;

    &:hover {
      color: #66b1ff;
    }

    &:disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}

.login-btn {
  width: 100%;
  margin-top: 8px;
  border-radius: 0;
  padding: 10px 16px;
  font-weight: 600;
  letter-spacing: 6px;
  font-size: 14px;
  height: 42px;
}

.register-link {
  text-align: center;
  font-size: 14px;
  padding-bottom: 15px;
  margin-top: 5px;
  border-bottom: 2px solid #d9d9d9;

  span {
    color: #606266;
    vertical-align: middle;
  }

  .el-link {
    font-size: 14px;
    vertical-align: middle;
  }
}

.login-method-wrapper {
  margin-top: 10px;
}

.login-method-tabs {
  display: flex;
  justify-content: center;
  gap: 15px;

  .method-button {
    padding: 8px !important;
    border: none !important;
    background: transparent !important;
    border-radius: 50% !important;
    width: 40px;
    height: 40px;

    &:hover {
      background: #f5f7fa !important;
    }
  }
}

.agreement {
  text-align: center;
  font-size: 12px;
  color: #909399;
  margin-top: 10px;
  line-height: 1.6;

  .agreement-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    gap: 4px;

    .agree-checkbox {
      margin-right: 4px;

      // 防止点击复选框标签时触发链接
      :deep(.el-checkbox__label) {
        cursor: default;
        user-select: none;
      }
    }

    .agreement-links {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .el-link {
      font-size: 12px;
      vertical-align: baseline;

      &:hover {
        color: #409EFF;
      }
    }

    span {
      color: #909399;
      font-size: 12px;
    }
  }
}

.error-message {
  display: flex;
  align-items: center;
  color: #f84949;
  font-size: 12px;
  margin-top: 4px;
  height: 20px;

  .el-icon {
    margin-right: 4px;
    font-size: 14px;
  }
}

.success-message {
  display: flex;
  align-items: center;
  color: #67c23a;
  font-size: 12px;
  margin-top: 4px;
  height: 20px;

  .el-icon {
    margin-right: 4px;
    font-size: 14px;
  }
}

.wechat-login-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .wechat-qrcode {
    text-align: center;

    img {
      width: 200px;
      height: 200px;
      border: 1px solid #f0f0f0;
    }

    .tip {
      margin-top: 15px;
      color: #606266;
      font-size: 14px;
    }
  }
}

/* 弹窗样式 */
.policy-dialog {
  .el-dialog {
    width: 60% !important;
    border-radius: 12px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    margin-top: 8vh !important;

    .el-dialog__header {
      padding: 16px 20px;
      margin: 0;
      border-bottom: 1px solid #e6e6e6;

      .dialog-header h3 {
        margin: 0;
        font-size: 18px;
        font-weight: 600;
        color: #2c3e50;
      }
    }

    .el-dialog__body {
      padding: 20px;
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .el-dialog__footer {
      padding: 12px 20px;
      border-top: 1px solid #e6e6e6;
    }
  }
}

.dialog-content {
  flex: 1;
  overflow-y: auto;
  line-height: 1.6;
  color: #606266;
  padding-right: 10px;
  max-height: 60vh;

  h2 {
    color: #2c3e50;
    margin-top: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;
    font-size: 1.4em;
  }

  h3 {
    color: #34495e;
    margin-top: 18px;
    margin-bottom: 10px;
    font-size: 1.2em;
  }

  p, ul {
    margin-bottom: 12px;
    font-size: 14px;
  }

  ul {
    padding-left: 18px;

    li {
      margin-bottom: 6px;
    }
  }

  strong {
    color: #2c3e50;
  }
}

</style>